/* global Backbone:true, _:true, grecaptcha:true */

(function() {
  'use strict';

  let app = {};

  let useCaptchas = false;

  //check if captcha area exists
  if ($(".g-recaptcha").length) {
    useCaptchas = true;
  }

  app.Contact = Backbone.Model.extend({
    url: '/contact/',
    defaults: {
      success: false,
      errors: [],
      errfor: {},
      name: '',
      email: '',
      message: ''
    }
  });

  app.ContactView = Backbone.View.extend({
    el: '#contact',
    template: _.template($('#tmpl-contact').html()),
    events: {
      'submit form': 'preventSubmit',
      'click .btn-contact': 'contact'
    },
    initialize: function() {
      this.model = new app.Contact();
      this.listenTo(this.model, 'sync', this.render);
      this.render();
    },
    render: function() {
      this.$el.html(this.template(this.model.attributes));
      this.$el.find('[name="name"]').focus();
    },
    preventSubmit: function(event) {
      event.preventDefault();
    },
    contact: function() {
      let captchaResponse;


      if (useCaptchas) {
        captchaResponse = grecaptcha.getResponse();
      }

      if (captchaResponse == null || captchaResponse.length < 1) {
        console.log("No captcha");

        $(".alerts").append('<div class="alert alert-danger alert-dismissable"><button type="button" data-dismiss="alert" class="close">×</button>Captcha not filled out</div>');

        return;
      }

      this.$el.find('.btn-contact').attr('disabled', true);

      this.model.save({
        name: this.$el.find('[name="name"]').val(),
        email: this.$el.find('[name="email"]').val(),
        message: this.$el.find('[name="message"]').val(),
        response: captchaResponse
      });
    }
  });

  $(document).ready(function() {
    app.contactView = new app.ContactView();
  });

})();